module.exports = __webpack_public_path__ + "media/v2/components/blocks/IconGame/shared/img/survivor/touchdawn1-524697978d60aa6b1a6a8af50721bede.svg";